<nb-card [nbSpinner]="isSpinnerActive" nbSpinnerStatus="warning" *ngIf="isPageLoaded" [formGroup]="formGroup">
  <nb-card-header class="justify-content-between">
    <div class="d-flex flex-column col-12 p-0">
      <div class="d-flex align-items-center">
        <span>
          Tichet <b class="ml-3 mr-3">{{ ticketObj?.client?.client_name ?? ticket?.client_name ?? '' }}</b>
        </span>
        <button class="ml-auto" nbButton status="danger" (click)="dismiss(null)" title="Închide">
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      <div class="d-flex align-items-center flex-wrap">
        <ng-container *ngIf="ticketObj?.id; else newTicketForm">
          <b class="mr-2">Departament:</b>
          <span class="mr-4">{{ ticket?.category || 'CONTABILITATE' }}</span>
          <b class="mr-2">Importanță:</b>
          <span class="mr-4">{{ severityLabels[ticket?.severity] }}</span>
        </ng-container>
        <ng-template #newTicketForm>
          <div class="row w-100 mt-2">
            <div class="col-6">
              <label class="label">Departament</label>
              <nb-select fullWidth placeholder="Departament" formControlName="department">
                <nb-option *ngFor="let dept of departments" [value]="dept">{{ dept }}</nb-option>
              </nb-select>
            </div>
            <div class="col-3">
              <label class="label">Importanță</label>
              <nb-select fullWidth placeholder="Importanță" formControlName="severity"
  [status]="formGroup.controls['severity'].invalid && formGroup.controls['severity'].touched ? 'danger' : 'basic'">
                <nb-option value="0">Mică</nb-option>
                <nb-option value="1">Medie</nb-option>
                <nb-option value="2">Mare</nb-option>
              </nb-select>
              <span class="text-danger caption" *ngIf="formGroup.controls['severity'].invalid && formGroup.controls['severity'].touched">
                Câmp obligatoriu
              </span>
            </div>
            <div class="col-12 mb-2" *ngIf="formGroup.controls['department'].value && formGroup.controls['department'].value !== 'CONTABILITATE'">
              <label class="label">Titlu</label>
              <input nbInput fullWidth placeholder="Titlu tichet (max 100 caractere)"
                formControlName="title" maxlength="100"
                [status]="formGroup.controls['title'].invalid && formGroup.controls['title'].touched ? 'danger' : 'basic'">
              <span class="text-danger caption" *ngIf="formGroup.controls['title'].invalid && formGroup.controls['title'].touched">
                Câmp obligatoriu
              </span>
            </div>
            
            <div class="col-3" *ngIf="formGroup.controls['department'].value === 'CONTABILITATE'">
              <label class="label">Către</label>
              <nb-select fullWidth placeholder="Către" formControlName="toUserId"
                [status]="formGroup.controls['toUserId'].invalid && formGroup.controls['toUserId'].touched ? 'danger' : 'basic'">
                <nb-option *ngFor="let user of ticketSolver" [value]="user?.user_id">
                  {{ user?.user_firstname + ' ' + user?.user_lastname }}
                </nb-option>
              </nb-select>
              <span class="text-danger caption" *ngIf="formGroup.controls['toUserId'].invalid && formGroup.controls['toUserId'].touched">
                Câmp obligatoriu
              </span>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body *ngIf="isPageLoaded">
    <div class="row h-100" *ngIf="formGroup.controls['department'].value || messages.length > 0">
      <div class="col-12 chatContainer">
        <custom-chat #chatComponent [scrollBottom]="true">
          <div *nbCustomMessage="'tags'; let customMessageData">
            <div [innerHtml]=customMessageData></div>
          </div>
          <button class="asconFile" *nbCustomMessage="'asconFile'; let data" (click)="download(data.fileName)">
            <nb-icon [icon]="data.files[0].icon" *ngIf="!data.files[0].urlStyle && data.files[0].icon"></nb-icon>
            <div *ngIf="data.files[0].urlStyle" [style.background-image]="data.files[0].urlStyle"></div>
          </button>
          <nb-chat-message *ngFor="let msg of messages"
            [type]="msg.type"
            [message]="msg.message"
            [reply]="msg.reply"
            [sender]="msg.user?.name"
            [files]="msg.files"
            [date]="msg.date"
            [dateFormat]="'dd.MM.yyyy HH:mm'"
            [customMessageData]="{files:msg.files, fileName:msg.fileName}">
          </nb-chat-message>
          <textarea-chat-form autoresizeTextarea (send)="sendMessage($event)" [dropFiles]="true" #chatForm>
          </textarea-chat-form>
        </custom-chat>
      </div>
    </div>
  </nb-card-body>
</nb-card>